import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useUnit } from 'effector-react';
import { useChangeWorkspace, useDialog } from '@nx-frontend/shared/hooks';
import { rumTrackAction } from '@nx-frontend/shared/rum';
import { setActiveItemIdEvent } from '@nx-frontend/shared/store/feature-menu-tree';
import { $webEditor } from '@nx-frontend/shared/store/web-editor-store';
import { MenuType } from '@nx-frontend/shared/types';

interface UseNavigateWithCheckUnsavedChangesParams {
  routerPush: (url: string) => void;
}

export function useNavigateWithCheckUnsavedChanges(params?: UseNavigateWithCheckUnsavedChangesParams) {
  const dialog = useDialog();
  const changeWorkspace = useChangeWorkspace();
  const [webEditor] = useUnit([$webEditor]);
  const [setActiveItemId] = useUnit([setActiveItemIdEvent]);
  const router = useRouter();
  const t = useTranslations('webnotes');

  return (url: string) => {
    const [, , currentWorkspaceId, type, globalId] = window.location.pathname.split('/');
    const [, , targetWorkspaceId] = url.split('/');
    // check if the current route to page and has unsaved changes
    // then show confirm dialog
    if (type === 'page' && webEditor?.store.y.wspoolHasChangedWithoutSave()) {
      setActiveItemId({ id: `note#${globalId}`, menuType: MenuType.WEBNOTES_MENU });
      if (currentWorkspaceId !== targetWorkspaceId) {
        changeWorkspace(currentWorkspaceId);
      }
      rumTrackAction('navigate-with-unsaved-editor-changes', {
        currentWorkspaceId,
        targetWorkspaceId,
        currentUrl: window.location.href,
        targetUrl: url,
      });
      dialog({
        title: t('webnotes-unsaved_title'),
        text: t('webnotes-unsaved_popup_description'),
        confirmBtnText: t('webnotes-leave'),
        onConfirm: () => {
          if (currentWorkspaceId !== targetWorkspaceId) {
            changeWorkspace(targetWorkspaceId);
          }
          router.push(url);
        },
      });
      return;
    }
    router.push(url);
  };
}
